import { all, fork } from "redux-saga/effects";

import { alertsSagas } from "@app/store/mapLayers/alerts/sagas";
import { boundariesLayerSagas } from "@app/store/mapLayers/boundaries/sagas";
import { heatMapLayerSagas } from "@app/store/mapLayers/heatMap/sagas";
import { trafficLayerSagas } from "@app/store/mapLayers/traffic/sagas";
import { userLocationsSagas } from "@app/store/mapLayers/userLocations/sagas";

export function* mapLayersSagas() {
  yield all([
    fork(alertsSagas),
    fork(heatMapLayerSagas),
    fork(boundariesLayerSagas),
    fork(trafficLayerSagas),
    fork(userLocationsSagas),
  ]);
}
